/**
 * Auth Service — Xyden Leadership Assessment Platform
 * Step 6F Green Phase
 */

import { apiClient, ServiceError } from '../apiClient';
import type { User } from '../../types';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  token: string;
  session_id?: string;
  user: User;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>(('/api/auth/login'), credentials);
  },

  async logout(): Promise<{ success: boolean }> {
    try {
      return await apiClient.post<{ success: boolean }>(('/api/auth/logout'));
    } catch (e: unknown) {
      if (e instanceof ServiceError && e.status === 401) {
        return { success: true };
      }
      throw e;
    }
  },

  async refreshToken(token?: string): Promise<{ token: string }> {
    return apiClient.post<{ token: string }>(('/api/auth/refresh'), { refresh_token: token });
  },

  async getCurrentUser(): Promise<User> {
    return apiClient.get<User>(('/api/auth/me'));
  },
};

export default authService;
